import { useState, useRef } from 'react';

export const useTrainingTimer = () => {
  const [isRunning, setIsRunning] = useState(false);
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const intervalRef = useRef(null);
  const startTimeRef = useRef(null);
  
  const start = () => {
    if (!isRunning) {
      setIsRunning(true);
      startTimeRef.current = Date.now() - (elapsedSeconds * 1000);
      
      intervalRef.current = setInterval(() => {
        const elapsed = Math.floor((Date.now() - startTimeRef.current) / 1000);
        setElapsedSeconds(elapsed);
      }, 1000);
    }
  };
  
  const pause = () => {
    if (isRunning) {
      setIsRunning(false);
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }
  };
  
  const reset = () => {
    pause();
    setElapsedSeconds(0);
    startTimeRef.current = null;
  };
  
  const setElapsed = (seconds) => {
    setElapsedSeconds(seconds);
    if (isRunning) {
      startTimeRef.current = Date.now() - (seconds * 1000);
    }
  };
  
  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  
  return { 
    elapsedSeconds, 
    formattedTime: formatTime(elapsedSeconds),
    isRunning, 
    start, 
    pause, 
    reset,
    setElapsed 
  };
};